import { Alert, Snackbar } from "@mui/material";
import { ChatBox } from "components/ChatBox";
import Loader from "components/Loader";
import TokenRefresh from "Helpers/TokenRefresh";
import RequestChat from "modals/RequestChat";
import { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import {
  currentChatbox,
  currentChatObject,
  incrementUnreadCount,
} from "redux/reducers/chatbox";
import { currentLoader } from "redux/reducers/loader";
import { currentQuickChatTutorId } from "redux/reducers/quickChatModal";
import {
  changeToken,
  currentToken,
  currentUserData,
} from "redux/reducers/token";
import socket from "socket";
import {
  currentQuickChatRequest,
  quickChatRequest,
} from "../src/redux/reducers/quickChatModal";
import { changeSnackbar } from "../src/redux/reducers/snackbar";
import { ChatMessage } from "./components/ChatBox/ChatMessage";
import Routes from "./Routes";

function App() {
  const value = useSelector((state) => state.snackbar.value);
  const tutorId = useSelector(currentQuickChatTutorId);
  const loader = useSelector(currentLoader);
  const dispatch = useDispatch();
  const userData = useSelector(currentUserData);
  const token = useSelector(currentToken);
  const isChatBoxActive = useSelector(currentChatbox);
  const currentChatObj = useSelector(currentChatObject);
  const currentQuickChatModal = useSelector(currentQuickChatRequest);
  const userId = userData?.id;
  const timeDifference = (date1, date2) => {
    return Math.floor((date1.getTime() - date2.getTime()) / 1000);
  };

  const refreshAccessToken = async () => {
    if (token) {
      const timeLeft = timeDifference(
        new Date(userData.exp * 1000),
        new Date()
      );
      if (timeLeft < 200) {
        await TokenRefresh();
        dispatch(changeToken());
      }
    }
  };

  useEffect(() => {
    setInterval(() => {
      refreshAccessToken();
    }, 5000);
    setInterval(() => {
      dispatch(changeToken());
    }, 1000);
    refreshAccessToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (token) {
      socket?.on("error", (error) => {
        console.error("WebSocket Error:", error);
        socket.disconnect();
      });

      socket?.on("connect", () => {
        if (socket.id !== undefined && socket.id !== null && socket.id !== "") {
          socket.emit("login", { userId });
        }
      });

      // ✅ **Listen for new messages & update unread count**
      socket?.on("new_message", (message) => {
        if (message.recipientId === userId) {
          console.log("📩 New Message Received:", message);
          dispatch(incrementUnreadCount()); // Increase unread count in Redux
        }
      });

      return () => {
        socket?.off("error");
        socket?.off("connect");
        socket?.off("new_message"); // Cleanup listener when component unmounts
      };
    } else {
      socket?.disconnect();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token]);

  return (
    <>
      <Helmet>
        <title>
          Battersea House - Affordable and High-Quality Online Tutors in the UK
          | Best Online Tutoring
        </title>
        <meta
          name="title"
          content="Battersea House - Affordable and High-Quality Online Tutors in the UK | Best Online Tutoring"
          key="title"
        />
        <meta
          name="description"
          content="Enabling students to achive academic excellence through world-class tutoring, personalised learning and immersive technologies"
          key="description"
        />
        <meta
          name="keywords"
          content="Batter Sea House, Batter Sea, House, Tutor, Course, Learn, Skill, Hire, Join"
          key="keywords"
        />
      </Helmet>
      <Routes />
      <Snackbar
        open={value?.isOpen}
        vertcle="top"
        horizontal="right"
        onClose={() => {
          dispatch(changeSnackbar({ ...value, isOpen: false }));
        }}
        autoHideDuration={6000}
      >
        <Alert
          onClose={() => {
            dispatch(changeSnackbar({ ...value, isOpen: false }));
          }}
          severity={value?.state}
        >
          {value?.message}
        </Alert>
      </Snackbar>
      {loader ? <Loader /> : null}
      {isChatBoxActive ? (
        <ChatBox
          closeChat={() => {
            dispatch(ChatMessage(true));
          }}
        />
      ) : null}
      {currentChatObj.isSingle ? (
        <ChatMessage className={``} closeChat={currentChatObj.isSingle} />
      ) : null}
      {/* quickChatModal */}
      {currentQuickChatModal ? (
        <RequestChat
          closepopup={() => dispatch(quickChatRequest(false))}
          tutorId={tutorId}
        ></RequestChat>
      ) : null}
    </>
  );
}
export default App;
